const attendaceStatus = [
  { value: 1, label: "Present" },
  { value: 2, label: "Present: Late" },
  { value: 3, label: "Present: Overtime" },
  { value: 4, label: "Present : Regularization Approved" },
  { value: 5, label: "Absent: Regularization Rejected" },
  { value: 6, label: "Regularization: Pending" },
  { value: 7, label: "Leave" },
];

export default attendaceStatus
